// extracted by mini-css-extract-plugin
module.exports = {"importantRemarks":"ImportantRemarks_importantRemarks__1iXx-","strong":"ImportantRemarks_strong__11dQU"};